export default "__VITE_ASSET__tjO006qh__"